<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="tab.conveyorConfig" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(warehouse)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="conveyor.no" title="business.label.conveyor"/>
        <vxe-column field="startPosition" title="business.label.sourcePosition"/>
        <vxe-column field="endPosition" title="business.label.targetPosition"/>
        <vxe-column field="pickupMode.name" title="business.label.pickupMode"/>
        <vxe-column field="direction.name" title="business.label.direction"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <vxe-modal v-model="visible" :loading="loading" :title="$t('tab.conveyorConfig')" type="confirm" width="40%" @confirm="confirm">
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="config" :rules="rules" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -4%;margin-right: 4%">
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.conveyor')" prop="conveyor">
              <vxe-select v-model="config.conveyor.id" :options="conveyors" clearable style="width: 100%" @change="onConveyorChange"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.sourcePosition')">
              <vxe-input v-model="config.startPosition" clearable style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.targetPosition')">
              <vxe-input v-model="config.endPosition" clearable style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.pickupMode')">
              <vxe-select v-model="config.pickupMode.id" :options="pickupModes" clearable style="width: 100%" @change="onPickupModeChange"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.direction')">
              <vxe-select v-model="config.direction.id" :options="directions" clearable style="width: 100%" @change="onDirectionChange"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-modal>
  </div>
</template>
<script>
import { deleteOne, findAll, findOne, save } from '@/api/Api'
import { Warehouse } from '@/api/dto/common/Warehouse'
import { ConveyorConfig } from '@/api/dto/config/ConveyorConfig'
import { Dictionary } from '@/api/dto/admin/Dictionary'

export default {
  name: 'ConveyorConfig',
  props: {
    conveyors: { type: Array, default: [] },
    pickupModes: { type: Array, default: [] },
    directions: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      visible: false,
      warehouse: new Warehouse(),
      list: [],
      config: new ConveyorConfig(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        conveyor: [{ required: true, type: 'string', message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  methods: {
    onConveyorChange(event) {
      this.config.conveyor = new Dictionary({ id: event.value })
    },
    onPickupModeChange(event) {
      this.config.pickupMode = new Dictionary({ id: event.value })
    },
    onDirectionChange(event) {
      this.config.direction = new Dictionary({ id: event.value })
    },
    refresh(warehouse) {
      this.warehouse = warehouse
      if (this.warehouse.isNew()) {
        return this.$message.warning('请先选择仓库')
      }
      this.loading = true
      findAll('conveyorConfigFactory', { 'warehouse.id': this.warehouse.id }).then(res => {
        if (res.success) {
          this.list = res.result.map(item => {
            return new ConveyorConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.visible = true
      this.config = new ConveyorConfig()
    },
    edit(row, copy) {
      this.visible = true
      this.loading = true
      findOne('conveyorConfigFactory', { id: row.id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.config = new ConveyorConfig(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const config = this.config.toJSONObject()
      config.warehouse = this.warehouse
      save('conveyorConfigPersister', config).then(res => {
        if (res.success) {
          this.config = new ConveyorConfig(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.refresh(this.warehouse)
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('conveyorConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.refresh(this.warehouse)
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.list.splice(this.list.indexOf(row), 1)
      }
    }
  }
}
</script>